'use client';

import Error500 from '@component/error/error500/Error500';

export default function Error() {
  return <Error500 />;
}
